import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザのサマリ情報を取得する
 *
 * @param {String} orgcode 組織コード
 * @returns {Response} レスポンスデータ
 */
export function getUserSummary (uid) {
  return request.get(`/users/${uid}`, {
    validateStatus: (status) => [
      http.OK,
      http.NotFound
    ].includes(status)
  })
}
